import { render, staticRenderFns } from "./OpportunitiesColumn.vue?vue&type=template&id=6160d0ca"
import script from "./OpportunitiesColumn.vue?vue&type=script&lang=js"
export * from "./OpportunitiesColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6160d0ca')) {
      api.createRecord('6160d0ca', component.options)
    } else {
      api.reload('6160d0ca', component.options)
    }
    module.hot.accept("./OpportunitiesColumn.vue?vue&type=template&id=6160d0ca", function () {
      api.rerender('6160d0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Opportunities/OpportunitiesDasboard/OpportunitiesColumn.vue"
export default component.exports